<script>
import UserTariff from '../../user/UserTariff.vue';

export default {
  name: 'AdminUserListTariffCell',
  components: { UserTariff },
  props: {
    row: Object,
  },
};
</script>

<template lang="pug">
  UserTariff.tariff(v-bind="row.tariffValue")
</template>

<style scoped lang="scss">
.tariff {
  width: 100%;
}
</style>
